import React from "react";

const Section1Introduction = () => (
  <>
    <h2>1. Introduction</h2>
    <p>
    Comparedly.com serves as a sophisticated social media analytics tool, 
    meticulously engineered to furnish users with comprehensive and actionable insights into their 
    social media performance and the intricate dynamics of audience engagement. 
    This Privacy Policy is a formal declaration of Comparedly Ltd.’s unwavering commitment to 
    transparency and the protection of user privacy. Its paramount purpose is to elucidate in 
    detail the precise methods by which Comparedly Ltd. gathers, employs, processes, and safeguards 
    the personal data of its users, ensuring strict adherence to the stringent stipulations and 
    legal mandates set forth by both the General Data Protection Regulation (GDPR) and the UK GDPR. 
    </p>
  </>
);

export default Section1Introduction;
